// 图片懒加载
import { Lazyload } from 'vant'
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Lazyload, { lazyComponent: true })
})
